import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './pages/home/home.component';
import { ContactComponent } from './pages/contact/contact.component';
import { AboutComponent } from './pages/about/about.component';
import { HeaderComponent } from './partial/header/header.component';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';

import { MissingTranslationHandler, TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { TranslationLoadedService } from './services/TranslationLoadedService';
import { MultiTranslateHttpLoader, MyMissingTranslationHandler } from './services/MyMissingTranslationHandler';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CategoriesComponent } from './pages/categories/categories.component';
import { TermsConditionsComponent } from './pages/terms-conditions/terms-conditions.component';
import { sharedLibModule } from '../../../shared/src/lib/shared-lib.module';
import { HomeNewComponent } from './pages/home-new/home-new.component';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiInterceptor } from './helpers/ApiInterceptor';
import { JobsComponent } from './pages/jobs/jobs.component';
import { TimeAgoPipe } from './helpers/time-ago.pipe';
import { CareersComponent } from './pages/careers/careers.component';
import { JobDetailsComponent } from './pages/careers/job-details/job-details.component';
export function HttpLoaderFactory(httpClient: HttpClient, translationLoaded: TranslationLoadedService): TranslateLoader {
  return new MultiTranslateHttpLoader(httpClient, translationLoaded);
}
export function initializeTranslations(translationLoadedService: TranslationLoadedService): () => Promise<void> {
  return async (): Promise<void> => {
    return new Promise(resolve => {
      translationLoadedService.loaded$().subscribe(() => resolve());
    });
  };
}

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    HomeComponent,
    ContactComponent,
    AboutComponent,
    CategoriesComponent,
    TermsConditionsComponent,
    HomeNewComponent,
    JobsComponent,
    CareersComponent,
    JobDetailsComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    AppRoutingModule,
    ReactiveFormsModule,
    sharedLibModule,
    TranslateModule.forRoot({
      defaultLanguage: localStorage.getItem('language') || 'ar',
      loader: {
        provide: TranslateLoader,
        useFactory: (HttpLoaderFactory),
        deps: [HttpClient, TranslationLoadedService]
      },
      missingTranslationHandler: { provide: MissingTranslationHandler, useClass: MyMissingTranslationHandler },
    }),
    TimeAgoPipe
  ],
  providers: [
    provideAnimations(),
    provideHttpClient(
      withInterceptorsFromDi(),
    ),
    { provide: HTTP_INTERCEPTORS, useClass: ApiInterceptor, multi: true },
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {
  constructor(
    private activatedRoute: ActivatedRoute,
    public translate: TranslateService,
    private router: Router,
  ) {
    this.activatedRoute.queryParams.subscribe(params => {
      if (params['lang'] && (params['lang'] == 'ar' || params['lang'] == 'en')) {
        let paramLang = params['lang'];
        this.router.navigate([], {
          queryParams: { lang: '' },
          queryParamsHandling: 'merge',
        });
        if (localStorage.getItem('language') !== paramLang) {
          translate.use(paramLang);
          localStorage.setItem('language', paramLang);
          location.reload();
        }
      }
    });
  }
}
